export const kolliID = [
  {
    type: 'text',
    name: 'additionalDeliveryId1',
    label: 'kolliID'
  },
  {
    type: 'text',
    name: 'additionalDeliveryId2',
    label: 'kolliID'
  }
];
